<template>
    <div class="tw-w-full tw-mb-6">
        <section :class="theme === 'dark' ? 'tw-bg-[#1A1D21]' : 'tw-bg-white'" class="tw-rounded-2xl tw-p-6 tw-shadow-2xl">
            <div class="tw-mb-8">
                <h2 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold tw-text-xl">Aeração</h2>
            </div>
            <div class="tw-mb-8">
                <div class="tw-flex tw-gap-6">
                    <button
                        @click="activateTabStatus(true)"
                        :class="[
                            'tw-pb-4 tw-font-semibold tw-text-sm tw-transition-none',
                            tabStatus
                                ? 'tw-text-emerald-600 tw-border-b-2 tw-border-emerald-600'
                                : (theme === 'dark' ? 'tw-text-slate-400 hover:tw-text-slate-300' : 'tw-text-slate-500 hover:tw-text-slate-600')
                        ]"
                    >
                        Status
                    </button>
                    <button
                        @click="activatetabHistorico(true)"
                        :class="[
                            'tw-pb-4 tw-font-semibold tw-text-sm tw-transition-none',
                            tabHistorico
                                ? 'tw-text-emerald-600 tw-border-b-2 tw-border-emerald-600'
                                : (theme === 'dark' ? 'tw-text-slate-400 hover:tw-text-slate-300' : 'tw-text-slate-500 hover:tw-text-slate-600')
                        ]"
                    >
                        Histórico Semanal
                    </button>
                </div>
            </div>
            <div v-if="tabStatus">
                <div v-if="aeracao && aeracao.aeracao" class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-mb-6">
                    <div class="tw-flex tw-flex-col tw-gap-4 tw-relative"> <div class="tw-flex tw-flex-col tw-gap-4">
                            <div class="tw-flex tw-items-start tw-gap-3 tw-p-2">
                                <div class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-lg tw-flex-shrink-0" :style="{ backgroundColor: avaliacao.cor + '20' }">
                                    <svg v-if="avaliacao.ok" class="tw-w-5 tw-h-5" :style="{ color: avaliacao.cor }" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                                    </svg>
                                    <svg v-else class="tw-w-5 tw-h-5" :style="{ color: avaliacao.cor }" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                                    </svg>
                                </div>
                                <div class="tw-flex-1 tw-min-w-0">
                                    <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider">Status</p>
                                    <p :style="{ color: avaliacao.cor }" class="tw-font-bold tw-text-sm tw-whitespace-pre-line">{{ avaliacao.titulo }}</p>
                                    <ul v-if="avaliacao.motivos.length" class="tw-mt-1 tw-space-y-0.5">
                                        <li v-for="m in avaliacao.motivos" :key="m" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-600'" class="tw-text-xs tw-flex tw-gap-1.5">
                                            <span :style="{ color: avaliacao.cor }">•</span>{{ m }}
                                        </li>
                                    </ul>
                                    <p v-if="avaliacao.nota" :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-mt-1">{{ avaliacao.nota }}</p>
                                </div>
                            </div>

                            <div class="tw-flex tw-items-center tw-gap-3 tw-p-2">
                                <div :class="theme === 'dark' ? 'tw-bg-blue-500/20' : 'tw-bg-blue-100'" class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-lg">
                                    <svg class="tw-w-5 tw-h-5 tw-text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.49 3.17c-.325-1.423-2.655-1.423-2.98 0a1.724 1.724 0 01-2.573 1.066c-1.248-.75-2.91.912-2.16 2.16a1.724 1.724 0 01-1.066 2.573c-1.423.325-1.423 2.655 0 2.98a1.724 1.724 0 011.066 2.573c-.75 1.248.912 2.91 2.16 2.16a1.724 1.724 0 012.573 1.066c.325 1.423 2.655 1.423 2.98 0a1.724 1.724 0 012.573-1.066c1.248.75 2.91-.912 2.16-2.16a1.724 1.724 0 011.066-2.573c1.423-.325 1.423-2.655 0-2.98a1.724 1.724 0 01-1.066-2.573c.75-1.248-.912-2.91-2.16-2.16a1.724 1.724 0 01-2.573-1.066zM10 13a3 3 0 100-6 3 3 0 000 6z"/>
                                    </svg>
                                </div>
                                <div class="tw-flex-1">
                                    <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider">Programa</p>
                                    <p :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold tw-text-sm">{{ descricaoPrograma }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="tw-flex tw-flex-col tw-relative"> 
                        <div v-if="aeracao && aeracao.horas_aeradas" 
                            class="tw-flex tw-flex-col tw-p-4 tw-shadow-sm">
                            <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" 
                            class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-widest tw-mb-3">
                                Horas Aeradas Totais
                            </p>
                            <div class="tw-flex tw-items-center tw-gap-1">
                                <svg class="tw-w-3.5 tw-h-3.5 tw-text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 8v4l2.5 2.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span :class="theme === 'dark' ? 'tw-text-emerald-400' : 'tw-text-emerald-700'" class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-tight">
                                    {{ horasAeradasFormatadas }}
                                </span>
                            </div>
                        </div>
                        <div v-if="programaParametros != 8" 
                            class="tw-flex tw-flex-col tw-rounded-xl tw-p-4 tw-shadow-sm">
                            
                            <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" 
                            class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-widest tw-mb-3">
                                Configuração do Programa
                            </p>
                            <p v-if="programaDivergente && !isTermocloud" class="tw-text-xs tw-mb-3 tw-leading-snug" :class="theme === 'dark' ? 'tw-text-amber-400' : 'tw-text-amber-700'">
                                Aguardando o equipamento aplicar o novo programa. Em execução: {{ nomePrograma(programaEmExecucao) }}.
                            </p>

                            <div class="tw-flex xs:tw-flex-col sm:tw-flex-row tw-flex-wrap tw-gap-2">
                                <div v-if="[1, 2].includes(programaParametros) && parametrosAtuais && parametrosAtuais.temperatura_minima != null" class="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-orange-500/10 tw-border tw-border-orange-500/20">
                                    <span class="tw-text-orange-500 tw-text-[10px] tw-font-black">TEMPERATURA</span>
                                    <span :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-xs tw-font-bold">
                                        {{ inteiro(parametrosAtuais.temperatura_minima) }}° - {{ inteiro(parametrosAtuais.temperatura_maxima) }}°C
                                    </span>
                                </div>
                                <div v-if="[1, 2, 3].includes(programaParametros) && parametrosAtuais && parametrosAtuais.umidade_minima != null" class="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-blue-500/10 tw-border tw-border-blue-500/20">
                                    <span class="tw-text-blue-500 tw-text-[10px] tw-font-black">UMIDADE</span>
                                    <span :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-xs tw-font-bold">
                                        {{ inteiro(parametrosAtuais.umidade_minima) }}% - {{ inteiro(parametrosAtuais.umidade_maxima) }}%
                                    </span>
                                </div>
                                <div v-if="programaParametros === 2 && parametrosAtuais && parametrosAtuais.horario_inicio && parametrosAtuais.horario_final" class="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-emerald-500/10 tw-border tw-border-emerald-500/20">
                                    <span class="tw-text-emerald-500 tw-text-[10px] tw-font-black">HORÁRIO</span>
                                    <span :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-xs tw-font-bold">
                                        {{ hhmm(parametrosAtuais.horario_inicio) }} - {{ hhmm(parametrosAtuais.horario_final) }}
                                    </span>
                                </div>
                                <div v-if="[4, 5, 6, 7].includes(programaParametros) && parametrosAtuais && parametrosAtuais.media != null" class="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-px-3 tw-py-2 tw-rounded-lg tw-bg-purple-500/10 tw-border tw-border-purple-500/20">
                                    <span class="tw-text-purple-500 tw-text-[10px] tw-font-black">MÉDIA</span>
                                    <span :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-xs tw-font-bold">
                                        {{ inteiro(parametrosAtuais.media) }}ºC
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="motoresAtuais && aeracaoDataAtual" class="tw-mb-6">
                    <MotorList 
                        :motores="motoresAtuais" 
                        :aeracao-data="aeracaoDataAtual" 
                        :modoOperacao="modoOperacao"
                        :aeracao-possivel="avaliacao.ok"
                        :theme="theme"
                    />
                </div>
            </div>

            <!-- Chart Tab -->
            <div v-else>
                <div style="min-height: 400px">
                    <canvas id="aeracaoChart" style="max-height: 350px"></canvas>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import MotorList from './MotorList.vue';
import { Chart } from 'chart.js';
import { nextTick } from 'vue';

export default {
    components: {
        MotorList
    },
    props: {
        aeracao: {
            type: Object
        },
        modoOperacao: {
            type: Number
        },
        programa: {
            default: () => ({})
        },
        bloqueioAeracao: {
            type: [Number, Boolean, String],
            default: null
        },
        produto: {
            type: Object,
            default: null
        },
        leituraEmAndamento: {
            type: Boolean,
            default: false
        },
        parametrosProgramas: {
            type: [Object, Array],
            default: null
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    data() {
        return {
            estacaoAtual: null,
            configUnidade: null,
            minutoAtual: 0,
            tabStatus: true,
            tabHistorico: false,
            chart: null,
            motoresAtualizados: null,
            aeracaoDataAtualizada: null,
            intervaloMotores: null,
        }
    },
    mounted() {
        this.intervaloMotores = setInterval(this.atualizarMotores, 15000);
        this.carregarEstacao();
        this.intervaloEstacao = setInterval(this.carregarEstacao, 60000);
        this.carregarConfigUnidade();
        this.atualizarRelogio();
        this.intervaloRelogio = setInterval(this.atualizarRelogio, 30000);
    },
    beforeUnmount() {
        if (this.intervaloMotores) clearInterval(this.intervaloMotores);
        if (this.intervaloEstacao) clearInterval(this.intervaloEstacao);
        if (this.intervaloRelogio) clearInterval(this.intervaloRelogio);
    },
    watch: {
        aeracao() {
            this.motoresAtualizados = null;
            this.aeracaoDataAtualizada = null;
        },
        theme() {
            if (this.tabHistorico) {
                nextTick(() => {
                    this.renderChart();
                });
            }
        },
    },
    methods: {
        atualizarRelogio() {
            const d = new Date();
            this.minutoAtual = d.getHours() * 60 + d.getMinutes();
        },
        async carregarConfigUnidade() {
            const unidadeId = this.$route && this.$route.params && this.$route.params.unidade;
            if (!unidadeId) return;
            try {
                this.configUnidade = await this.$store.dispatch('unidade/getParametrosConfiguracoes', unidadeId);
            } catch (e) {
                this.configUnidade = null;
            }
        },
        minutos(hora) {
            const m = /^(\d{1,2}):(\d{2})/.exec(String(hora || ''));
            return m ? Number(m[1]) * 60 + Number(m[2]) : null;
        },
        hhmm(hora) {
            const m = /^(\d{1,2}):(\d{2})/.exec(String(hora || ''));
            return m ? `${m[1].padStart(2, '0')}:${m[2]}` : hora;
        },
        dentroHorario(inicio, fim) {
            const ini = this.minutos(inicio);
            const f = this.minutos(fim);
            if (ini === null || f === null) return false;
            const agora = this.minutoAtual;
            if (ini === f) return true;
            return ini < f ? agora >= ini && agora <= f : agora >= ini || agora <= f;
        },
        inteiro(v) {
            const n = Number(v);
            return v === null || v === undefined || v === '' || Number.isNaN(n) ? v : Math.round(n);
        },
        fmt(v) {
            return Number(v).toLocaleString('pt-BR', { maximumFractionDigits: 1 });
        },
        verificarFaixa(motivos, nome, valor, minimo, maximo, un) {
            const v = Number(valor);
            const lo = minimo == null || minimo === '' ? null : Number(minimo);
            const hi = maximo == null || maximo === '' ? null : Number(maximo);
            if (Number.isNaN(v)) return;
            if (lo !== null && v < lo) motivos.push(`${nome} fora dos parâmetros (${this.fmt(v)}${un} < ${this.fmt(lo)}${un})`);
            else if (hi !== null && v > hi) motivos.push(`${nome} fora dos parâmetros (${this.fmt(v)}${un} > ${this.fmt(hi)}${un})`);
        },
        equilibrioHigroscopico(temperatura, umidade) {
            const pr = this.produto;
            if (!pr) return null;
            const a = Number(pr.a);
            const b = Number(pr.b);
            const c = Number(pr.c);
            const t = Number(temperatura);
            const ur = Number(umidade);
            if (!(a > 0) || !(c > 0) || Number.isNaN(b) || Number.isNaN(t) || !(ur > 0 && ur < 100) || t + b <= 0) return null;
            const ue = Math.pow(Math.log(1 - ur / 100) / (-a * (t + b)), 1 / c);
            return Math.round(((100 * ue) / (100 + ue)) * 10) / 10;
        },
        nomePrograma(numero) {
            return {
                1: 'Programa Livre', 2: 'Programa Livre Temporizado', 3: 'Programa Equilíbrio Higroscópico',
                4: 'Programa Curva 1', 5: 'Programa Curva 2', 6: 'Programa Curva 3', 7: 'Programa Curva 4', 8: 'Programa Personalizado',
            }[numero] || `Programa ${numero}`;
        },
        async carregarEstacao() {
            const unidadeId = this.$route && this.$route.params && this.$route.params.unidade;
            if (!unidadeId) return;
            try {
                const resposta = await this.$store.dispatch('unidade/getEstacaoByUnidade', unidadeId);
                const e = resposta && resposta.estacao;
                this.estacaoAtual = e && e.temperatura != null && e.umidade != null
                    ? { temperatura: Number(e.temperatura), umidade: Number(e.umidade), chuva: Number(e.chuva) === 1 }
                    : null;
            } catch (e) {
                this.estacaoAtual = null;
            }
        },
        async atualizarMotores() {
            const siloId = this.$route.params.silo;
            if (!siloId || document.hidden || !this.tabStatus) return;
            try {
                const silo = await this.$store.dispatch('silo/fetchSiloById', siloId);
                if (String(silo?.id) !== String(this.$route.params.silo)) return;
                if (silo?.aeracao?.motores) {
                    this.motoresAtualizados = silo.aeracao.motores;
                }
                if (silo?.aeracao?.aeracao?.data) {
                    this.aeracaoDataAtualizada = silo.aeracao.aeracao.data;
                }
            } catch (error) {
                console.error('Erro ao atualizar motores:', error);
            }
        },
        activateTabStatus (action) {
            this.tabStatus = action;
            this.tabHistorico = false;
        },
        activatetabHistorico (action) {
            this.tabHistorico = action;
            this.tabStatus = false;
            nextTick(() => {
                this.renderChart();
            });
        },

        renderChart() {
            if (this.aeracao && this.aeracao.aeracao && this.aeracao.horas_aeradas && this.aeracao.horas_aeradas.horas_week) {
                const canvas = document.getElementById('aeracaoChart');
                if (!canvas) {
                    console.error('Canvas aeracaoChart não encontrado');
                    return;
                }

                const dados = this.aeracao.horas_aeradas.horas_week;
                const labels = this.getLast7Days();
                const hours = labels.map(date => {
                    const buscaDados = dados.find(item => item.date === date);
                    const totalHoras = buscaDados ? buscaDados.total_horas / 3600 : 0;
                    return totalHoras;
                });

                if (this.chart) {
                    this.chart.destroy();
                }

                const ctx = canvas.getContext('2d');
                const isDark = this.theme === 'dark';
                const textColor = isDark ? '#cbd5e1' : '#334155';
                const gridColor = isDark ? '#334155' : '#e2e8f0';
                
                this.chart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Total de Horas',
                            data: hours,
                            backgroundColor: '#10b981',
                            borderColor: '#059669',
                            borderWidth: 1,
                            fill: true,
                            borderRadius: 6,
                            size: 10
                        }]
                    },
                    options: {
                        plugins: {
                            legend: {
                                labels: {
                                    color: textColor,
                                    font: { size: 12 }
                                }
                            },
                            title: {
                                display: true,
                                text: 'Histórico de Aeração',
                                color: textColor,
                                font: {
                                    size: 14,
                                    weight: 'bold'
                                }
                            },
                            subtitle: {
                                display: true,
                                text: 'Últimos 7 dias: Tempo Aerado',
                                color: textColor,
                                font: {
                                    size: 12
                                }
                            },
                        },
                        scales: {
                            x: {
                                title: {
                                    display: true,
                                    text: 'Data',
                                    color: textColor
                                },
                                ticks: {
                                    color: textColor
                                },
                                grid: {
                                    color: gridColor
                                },
                                reverse: true
                            },
                            y: {
                                title: {
                                    display: true,
                                    text: 'Total de Horas',
                                    color: textColor
                                },
                                ticks: {
                                    color: textColor
                                },
                                grid: {
                                    color: gridColor
                                },
                                beginAtZero: true
                            }
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    }
                });
            }
        },



        getLast7Days() {
            const today = new Date();
            const dates = [];
            for (let i = 6; i >= 0; i--) {
                const date = new Date(today);
                date.setDate(today.getDate() - i);
                dates.push(this.formatDate(date));
            }
            return dates;
        },

        formatDate(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        formatarDataPTBR(dataISO) {
            const data = new Date(dataISO);
            
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0'); 
            const ano = data.getFullYear();

            const horas = String(data.getHours()).padStart(2, '0');
            const minutos = String(data.getMinutes()).padStart(2, '0');
            const segundos = String(data.getSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
        }
    },
    computed: {
        estacaoAvaliacao() {
            return this.estacaoAtual || (this.aeracao && this.aeracao.estacao) || null;
        },
        programaEmExecucao() {
            return Number(this.aeracao && this.aeracao.aeracao && this.aeracao.aeracao.programa) || null;
        },
        programaParametros() {
            return (this.programa && this.programa.numero) || this.programaEmExecucao;
        },
        isTermocloud() {
            const unidade = this.$store && this.$store.state.unidade && this.$store.state.unidade.unidade;
            return String((unidade && unidade.tipo_produto) || '').toLowerCase() === 'termocloud';
        },
        programaDivergente() {
            return !!(this.programaEmExecucao && this.programa && this.programa.numero && this.programaEmExecucao !== this.programa.numero);
        },
        parametrosAtuais() {
            const id = this.programa && this.programa.id;
            const configurados = id != null && this.parametrosProgramas ? this.parametrosProgramas[id] : null;
            if (configurados) return configurados;
            const registro = this.aeracao && this.aeracao.aeracao && this.aeracao.aeracao.parametros;
            return registro && !this.programaDivergente ? registro : null;
        },
        motoresAtuais() {
            return this.motoresAtualizados || this.aeracao?.motores || null;
        },
        aeracaoDataAtual() {
            return this.aeracaoDataAtualizada || this.aeracao?.aeracao?.data || null;
        },
        avaliacao() {
            const registro = (this.aeracao && this.aeracao.aeracao) || {};
            const modo = this.modoOperacao ?? registro.modo_operacao;
            if (modo != null && Number(modo) === 0) {
                return { titulo: 'Aeração Manual', cor: '#3b82f6', ok: false, motivos: [] };
            }
            const bloqueio = this.bloqueioAeracao ?? registro.bloqueio_aeracao;
            if (Number(bloqueio) === 1) {
                return { titulo: 'Aeração Bloqueada', cor: '#ef4444', ok: false, motivos: [] };
            }

            const motivos = [];
            const cfg = this.configUnidade;
            const e = this.estacaoAvaliacao;
            if (cfg) {
                if (cfg.horario_ponta === 'ativo' && this.dentroHorario(cfg.horario_ponta_inicio, cfg.horario_ponta_termino)) {
                    motivos.push(`Horário de ponta (${this.hhmm(cfg.horario_ponta_inicio)} - ${this.hhmm(cfg.horario_ponta_termino)})`);
                }
                if (e && e.chuva && cfg.aeracao_chuva !== 'ativo') {
                    motivos.push('Chovendo: aeração com chuva não permitida');
                }
                if (this.leituraEmAndamento && cfg.aeracao_termometria !== 'ativo') {
                    motivos.push('Leitura de termometria em andamento');
                }
            }

            const programa = this.programaParametros;
            const p = this.parametrosAtuais;
            const avaliavel = [1, 2, 3].includes(programa) && !!p;
            if (avaliavel) {
                if (!e) {
                    if (!motivos.length) {
                        return { titulo: 'Sem dados da estação', cor: '#94a3b8', ok: false, motivos: [], nota: 'Não foi possível avaliar as condições do programa.' };
                    }
                } else {
                    if ([1, 2].includes(programa)) {
                        this.verificarFaixa(motivos, 'Temperatura', e.temperatura, p.temperatura_minima, p.temperatura_maxima, '°');
                        this.verificarFaixa(motivos, 'Umidade', e.umidade, p.umidade_minima, p.umidade_maxima, '%');
                    }
                    if (programa === 3) {
                        const eg = this.equilibrioHigroscopico(e.temperatura, e.umidade);
                        if (eg === null) motivos.push('Não foi possível calcular o equilíbrio higroscópico do produto');
                        else this.verificarFaixa(motivos, 'Equilíbrio', eg, p.umidade_minima, p.umidade_maxima, '%');
                    }
                }
                if (programa === 2 && p.horario_inicio && p.horario_final && !this.dentroHorario(p.horario_inicio, p.horario_final)) {
                    const agora = `${String(Math.floor(this.minutoAtual / 60)).padStart(2, '0')}:${String(this.minutoAtual % 60).padStart(2, '0')}`;
                    motivos.push(`Horário fora dos parâmetros (${agora} fora de ${this.hhmm(p.horario_inicio)} - ${this.hhmm(p.horario_final)})`);
                }
            }

            if (motivos.length) {
                return { titulo: motivos.join('\n'), cor: '#f59e0b', ok: false, motivos: [] };
            }
            if (!avaliavel) {
                return { titulo: 'Aeração automática', cor: '#33b35a', ok: true, motivos: [], nota: 'As condições deste programa são avaliadas pelo equipamento.' };
            }
            return { titulo: 'Aeração Possível', cor: '#33b35a', ok: true, motivos: [] };
        },
        descricaoPrograma() {
            if (this.aeracao && this.aeracao.aeracao) {
                switch (this.programa.numero) {
                    case 1:
                        return "Programa Livre"        
                    case 2:
                        return "Programa Livre Temporizado"
                    case 3:
                        return "Programa Equilibrio Higroscopico"
                    case 4:
                        return "Programa Curva 1"    
                    case 5:
                        return "Programa Curva 2"   
                    case 6:
                        return "Programa Curva 3"   
                    case 7:
                        return "Programa Curva 4"       
                    case 8:
                        return "Programa Personalizado"       
                    default:
                        return ""
                }
            }
            return ""
        },
        horasAeradasFormatadas() {
            if (this.aeracao && this.aeracao.horas_aeradas && this.aeracao.horas_aeradas.horas_all) {
                const totalSegundos = this.aeracao.horas_aeradas.horas_all;

                const horas = Math.floor(totalSegundos / 3600);
                const minutos = Math.floor((totalSegundos % 3600) / 60);
                const segundos = totalSegundos % 60;

                return `${horas} Hrs ${minutos} min ${segundos} secs`;
            }
            return "";
        },

        dataInicio() {
            if (this.aeracao && this.aeracao.horas_aeradas && this.aeracao.horas_aeradas.data_primeira_aeracao) {
                const data = this.aeracao.horas_aeradas.data_primeira_aeracao.data_inicio;
                return  this.formatarDataPTBR(data);
            }

            return ""
        }
    },
}
</script>
